import React from 'react';
import { FJ731 } from '../../../services/j218Api';

interface WashGridProps {
  details: Partial<FJ731>[];
  setDetails: React.Dispatch<React.SetStateAction<Partial<FJ731>[]>>;
  isEditing: boolean;
  addDetailRow: () => void;
  deleteDetailRow: (idx: number) => void;
}

const WashLabelGrid: React.FC<WashGridProps> = React.memo(({
  details, setDetails, isEditing, addDetailRow, deleteDetailRow,
}) => {
  const updateRow = (idx: number, key: keyof FJ731, value: unknown) => {
    setDetails(prev => prev.map((row, i) =>
      i === idx ? { ...row, [key]: value } : row
    ));
  };

  return (
    <div className="wash-label-grid">
      <div className="grid-header">
        <h4>洗標明細</h4>
        {isEditing && (
          <button className="btn-add-row" onClick={addDetailRow}>+ 新增洗標</button>
        )}
      </div>
      <table>
        <thead>
          <tr>
            <th data-contract-field="fj731_02" style={{ width: 50 }}>項次</th>
            <th data-contract-field="fj731_11" style={{ width: 100 }}>洗標代碼</th>
            <th data-contract-field="fj731_12">洗標說明</th>
            {isEditing && <th data-acceptance-non-field style={{ width: 60 }}>操作</th>}
          </tr>
        </thead>
        <tbody>
          {details.map((row, idx) => (
            <tr key={idx}>
              <td data-contract-field="fj731_02">{row.fj731_02 || idx + 1}</td>
              <td>
                <input
                  data-contract-field="fj731_11"
                  value={row.fj731_11 || ''}
                  disabled={!isEditing}
                  onChange={e => updateRow(idx, 'fj731_11', e.target.value)}
                />
              </td>
              <td>
                <input
                  data-contract-field="fj731_12"
                  value={row.fj731_12 || ''}
                  disabled={!isEditing}
                  onChange={e => updateRow(idx, 'fj731_12', e.target.value)}
                />
              </td>
              {isEditing && (
                <td>
                  <button className="btn-delete-row" onClick={() => deleteDetailRow(idx)}>X</button>
                </td>
              )}
            </tr>
          ))}
          {details.length === 0 && (
            <tr><td colSpan={isEditing ? 4 : 3} className="empty-row">尚無明細</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
});

WashLabelGrid.displayName = 'WashLabelGrid';
export default WashLabelGrid;
